export interface GrowthLoyaltyTierRuleForm {
  localId: string;
  tierKey: string;
  minPoints: number | null;
}

export interface GrowthLoyaltyPointsRuleForm {
  localId: string;
  actionKey: string;
  points: number | null;
}

export interface GrowthLoyaltyRulesForm {
  tierRules: GrowthLoyaltyTierRuleForm[];
  pointsRules: GrowthLoyaltyPointsRuleForm[];
}

export function createDefaultLoyaltyRulesForm(): GrowthLoyaltyRulesForm {
  return { tierRules: [], pointsRules: [] };
}

export function createLoyaltyTierRule(): GrowthLoyaltyTierRuleForm {
  return { localId: crypto.randomUUID(), tierKey: '', minPoints: 0 };
}

export function createLoyaltyPointsRule(): GrowthLoyaltyPointsRuleForm {
  return { localId: crypto.randomUUID(), actionKey: '', points: 0 };
}

export function serializeLoyaltyRulesForm(form: GrowthLoyaltyRulesForm): {
  tierRulesJson: string;
  pointsRulesJson: string;
} {
  return {
    tierRulesJson: JSON.stringify(
      form.tierRules
        .filter(item => item.tierKey.trim())
        .map(item => ({
          tierKey: item.tierKey.trim(),
          minPoints: item.minPoints ?? 0
        }))
    ),
    pointsRulesJson: JSON.stringify(
      form.pointsRules
        .filter(item => item.actionKey.trim())
        .map(item => ({
          actionKey: item.actionKey.trim(),
          points: item.points ?? 0
        }))
    )
  };
}

export function validateLoyaltyRulesForm(form: GrowthLoyaltyRulesForm): string | null {
  for (const tier of form.tierRules) {
    if (!tier.tierKey.trim())
      return 'growth.crm.loyalty.ruleValidation.tierKeyRequired';
    if (tier.minPoints == null || tier.minPoints < 0)
      return 'growth.crm.loyalty.ruleValidation.minPointsInvalid';
  }

  for (const points of form.pointsRules) {
    if (!points.actionKey.trim())
      return 'growth.crm.loyalty.ruleValidation.actionKeyRequired';
    if (points.points == null || points.points < 0)
      return 'growth.crm.loyalty.ruleValidation.pointsInvalid';
  }

  return null;
}
